import i18n from "@breward/i18n";
import { EmptyState } from "../EmptyState/EmptyState";
import { useEffect, useState } from "react";

let MapContainer: any;
let TileLayer: any;
let Marker: any;

const importLeaflet = (setShow) => {
  import("react-leaflet").then((module) => {
    MapContainer = module.MapContainer;
    TileLayer = module.TileLayer;
    Marker = module.Marker;
    setShow(true);
  });
};

export const Map = ({ center, markers = [], zoom = 13 }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    importLeaflet(setShow);
  }, []);

  return (
    <div className="h-full w-full">
      {show && center && center?.length === 2 ? (
        <MapContainer
          style={{ height: "100%" }}
          center={[center?.[1], center?.[0]]}
          zoom={zoom}
          scrollWheelZoom={false}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {markers?.map((marker) => {
            return <Marker position={[marker?.[1] || 0, marker?.[0] || 0]} />;
          })}
        </MapContainer>
      ) : (
        <EmptyState
          message={i18n.t(
            "global:shared.MapDataUnavailable",
            "Map data unavailable"
          )}
        />
      )}
    </div>
  );
};
